import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { MUILoadingButton } from "../../components/buttons/MUILoadingButton";
import { AdjustmentProvider } from "../../types/api.types";
import { IconButton } from "common/components/buttons/IconButton";
import { CloseIcon } from "common/components/icons/CloseIcon";
import { SimpleDialog } from "../../components/dialogs/SimpleDialog";

interface AdjustmentsAdminDialogProps {
  open: boolean;
  onClose: () => void;
  isLoading?: boolean;
  providers?: AdjustmentProvider[];
  initialProvider?: string;
  initialDescription?: string;
  initialName: string;
  isNameEditable?: boolean;

  onSubmit?: (
    provider: string | undefined,
    description: string,
    name: string | undefined
  ) => void;
}

export const AdjustmentsAdminDialog: React.FC<AdjustmentsAdminDialogProps> = ({
  open,
  onClose,
  isLoading,
  initialProvider,
  providers,
  initialDescription,
  initialName,
  isNameEditable,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [selectedProvider, setSelectedProvider] = useState(initialProvider);
  const [description, setDescription] = useState(initialDescription);
  const [name, setName] = useState(initialName);

  return (
    <SimpleDialog
      title={t("adjustments.dialog.title")}
      open={open}
      onClose={onClose}
      isLoading={isLoading}
      onSubmit={() => onSubmit?.(selectedProvider, description ?? "", name)}
    >
      <div style={{ display: "flex", gap: "20px" }}>
        <div style={{ flex: 1 }}>
          <div>{t("adjustments.dialog.adjustment")}</div>
          <TextField
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={!isNameEditable}
            style={{ width: "100%" }}
          />
        </div>

        <div style={{ flex: 1 }}>
          {!!providers && (
            <>
              <div>{t("adjustments.dialog.defaultMethodology")}</div>
              <Select
                value={selectedProvider}
                onChange={(e) => setSelectedProvider(e.target.value)}
                style={{ width: "100%" }}
              >
                {providers?.map((provider) => (
                  <MenuItem key={provider.name} value={provider.name}>
                    {provider.fullname}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        </div>
      </div>
      <div style={{ marginTop: "20px" }}>
        {t("adjustments.dialog.description")}
      </div>
      <TextField
        multiline
        rows={4}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />
    </SimpleDialog>
  );
};
